import React from 'react';
import Routes from './Routes';
import './styles/tailwind.css';

function App() {
  return (
    <div className="app-gradient">
      <Routes />
    </div>
  );
}

export default App;